module.exports = __webpack_public_path__ + "img/media.c535c8c5.png";